// extracted by mini-css-extract-plugin
module.exports = {"typer-container":"Typer_typer-container__KOeBu","ghost":"Typer_ghost__ILQs_","typing":"Typer_typing__GAWHd"};